







































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WebsiteMobilePreview extends Vue {
  @Prop({ default: '295' }) readonly width?: string;
  @Prop({ default: '343' }) readonly height?: string;
}
